import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch } from 'react-redux';
import { activeVideoSoftware, desactiveVideoIndex, getIndexTable, putEditarVideoIndex, showIndexVideo } from '../../actions/indexActions';
import { FilterComponent } from '../../components/datatables/FilterComponent';
import { Alerts } from '../../components/messages/Alerts';
import {  isExtensionVideoValid } from '../../helpers/Helpers';
import { useForm } from '../../hooks/useForm';

export const EditarVideoInicial = () => {
    const dispatch = useDispatch();

    const [loadingdt, setLoadinGdt] = useState(true);
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [filterText, setFilterText] = useState('');
    const [data, setData] = useState([]);
    const [id, setId] = useState(0);
    const [updating, setUpdating] = useState(false);
    const [setvideoindex, setVideoIndex] = useState(null);
    const [ formState, handleInputName, reset, setValues ] = useForm({
        title_video: '',
    });

    const { title_video  } = formState;

    useEffect(() => {
        getData();
    }, []);
    
    
    
    const getData = async() => {
        
        const arr = [];
        const result = await dispatch(  getIndexTable() );
        
        (!result.ok) && Alerts({ 
            icon: 'error',
            title: 'Oops...',
            text: result.msg,
            footer: '<a href="">Qihotesl manuales</a>'
        });
    
        if(!result.ok){return}
           
       
        result.data.forEach( element => {
            arr.push({
                id: element.id,
                title_video: element.title_video,
                status: parseInt(element.status) 
            });
        });
        console.log('piuuu ', arr);
        setData(arr);
        setLoadinGdt(false);
    }
    
    
    
    const openCustomModal = async(id) => {
        const result = await dispatch( showIndexVideo(id) );
        (!result.ok) && Alerts({ 
            icon: 'error',
            title: 'Oops...',
            text: result.msg,
            footer: '<a href="">Qihotesl manuales</a>'
        });
        if(!result.ok){
            setTimeout(() => {
                document.getElementById('cerrarmodal').click();
            }, 800);
            return
        }

        setId(result.data.id);
        document.getElementById('title_video').value = result.data.title_video;
        
    }
    
    
    
    const desactivarVideoIndex = async(id) => {
        setLoadinGdt(true);
          const result = await dispatch(  desactiveVideoIndex(id) );
    
          (!result.ok) && Alerts({ 
            icon: 'error',
            title: 'Oops...',
            text: result.msg,
            footer: '<a href="">Qihotesl manuales</a>'
          });
          if(!result.ok){return}
    
        getData();
    }
    
    const activarVideoIndex = async(id) => {
        setLoadinGdt(true);
         const result = await dispatch(  activeVideoSoftware(id) );
    
         (!result.ok) && Alerts({ 
            icon: 'error',
            title: 'Oops...',
            text: result.msg,
            footer: '<a href="">Qihotesl manuales</a>'
          });
          if(!result.ok){return}
          getData()
    }
    
     const filteredItems = data.filter(
        item => item.title_video && item.title_video.toLowerCase().includes(filterText.toLowerCase()),
     );
    
     const columns = [
        {
            name: 'Titulo video',
            selector: row => row.title_video,
        },
        {
            name: 'Editar',
            button: true,
            cell: row => (
                
                (row.status == 1) 
                        ?
                          <button  target="_blank" onClick={ () => openCustomModal(row.id) } rel="noopener noreferrer" className="btn btn-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal">Editar</button>
                        :
                        ''
                
            ),
        },
        {
            name: 'Acciones',
            button: true,
            cell: row => (
                      (row.status == 1) 
                        ?
                        <button   onClick={ () => desactivarVideoIndex(row.id)}  rel="noopener noreferrer" className="btn btn-danger btn-sm">Desactivar</button>
                        :
                        <button   onClick={ () => activarVideoIndex(row.id)}     rel="noopener noreferrer" className="btn btn-warning btn-sm">Activar</button>           
            ),
        },
     ];
    
     
    
    
     const subHeaderComponentMemo = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };
    
        return (
            <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
        );
    }, [filterText, resetPaginationToggle]);




    const editarVideoIndex = async(event) =>{
         
        event.preventDefault();

                
        if (setvideoindex) {

            const softwarevalido = isExtensionVideoValid(setvideoindex);

            (!softwarevalido) &&
            Alerts({ 
                icon: 'error',
                title: 'Oops...',
                text: 'El tipo de archivo para el video no es permitido debe ser [.mp4, .mp3, .avi]!',
                footer: '<a href="#">Qihotels manuales</a>'
            });
            if(!softwarevalido) return;
        }
        
       setUpdating(true);  
         const result = await dispatch( putEditarVideoIndex({ id,  title_video, setvideoindex  }) );
       setUpdating(false); 
        console.log('result ', result);
       (!result.ok) && Alerts({ 
            icon: 'error',
            title: 'Oops...',
            text: result.msg,
            footer: '<a href="">Qihotesl manuales</a>'
        });
        if(!result.ok){return}

        (result.ok) && Alerts({ 
            icon: 'success',
            title: 'Oops...',
            text: result.msg,
            footer: '<a href="">Qihotesl manuales</a>'
        });

        getData();
    }

    const setDocumentVideoIndex = (event) => {
        setVideoIndex(event.target.files[0]);
    }

    
    
      return (
        <>
          <div className='container m-t-15p'>
            <DataTable
                title="Gestion software"
                columns={columns}
                data={filteredItems}
                progressPending={loadingdt}
                pagination
                paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
                selectableRows
                persistTableHead/>
          </div>


          <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Editar usuario</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={editarVideoIndex} autoComplete="off">
                            <div className="mb-3">
                                <label htmlFor="femail" className="form-label">Titulo video</label>
                                <input type="text" onChange={handleInputName} className="form-control" name="title_video" id="title_video" aria-describedby="Name input title manual to edit"/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="femail" className="form-label">Cambiar video</label>
                                <input className="form-control" type="file" name="video_index" id="video_index" onChange={setDocumentVideoIndex}/>
                            </div>
                            <div className="modal-footer">
                                {
                                (updating) 
                                ?
                                <h4>Un momento por favor...</h4>
                                :
                                <>
                                <button type="button" id='cerrarmodal' className="btn btn-dark" data-bs-dismiss="modal">Cerrar</button>
                                <button type="submit" className="btn btn-success">Editar usuario</button> 
                                </>
                                }
                            </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
      )
}






